<template>
  <div id="app">
    <router-view />
	<div class="weChatWrap">
		<div class="weChatPop">
			<img class="WeChat" src="./assets/images/WeChat.png" alt="">
			<div class="name">扫码加群</div>
			<div class="WeChatImg">
				<div class="smName">{{chatImg.title}}</div>
				<img :src="chatImg.url" alt="">
			</div>
		</div>
	</div>
  </div>
</template>

<style lang="scss">
html,
body,
#app {
  width: 100%;
}
#app {
  padding-top: 80px;
}
.clear {
  clear: both;
  display: block;
  line-height: 0;
  font-size: 0;
  height: 0;
  visibility: hidden;
}
.clear-fix:after {
  content: "\0020";
  display: block;
  height: 0;
  clear: both;
}
.content {
  min-height: calc(100vh - 260px);
}
#iconDivMain1 {
  display: none;
}
#div_company_mini {
  right: auto !important;
  // top:300px !important;
}
.weChatWrap{
	position: fixed;
	width: 60px;
	height: 70px;
	z-index: 999999;
    top: 416.8px;
	background-color: #f3cd70;
	border-top: 1px solid #fff;
	right: 0;
	text-align: center;
	cursor: pointer;
	.WeChat{
		margin-top: 8px;
		width: 35px;
		height: 35px;
	}
	.name{
		color: #fff;
		font-size: 12px;
	}
	.weChatPop{
		position: relative;
		.WeChatImg{
			display: none;
			position: fixed;
			width: 150px;
			height: 150px;
			right: 60px;
			top: 416.8px;
			border: 1px solid #f0f0f0;
			border-top: 1px solid #f3cd70;
			background-color: #fff;
			text-align: center;
			.smName{
				font-size: 13px;
				margin-top: 10px;
			}
			img{
				width: 115px;
				margin-top: 10px;
			}
		}
	}
	.weChatPop:hover .WeChatImg{
		display: block;
	}
}

</style>
<script>
export default {
  name: "app",
  components: {},
  data: function () {
    return {
		chatImg:{}
	};
  },
  mounted() {
    this.getWeChatImg();
  },
  methods: {
	getWeChatImg() {
      this.$axios
        .get(this.interfaceJson.serverAddress + "/api/contact/url")
        .then(res => {
          let data = res.data;
          if (data.code == 0) {
			  this.chatImg=data.data
			  this.$store.dispatch("setChatImg", data.data); 
          }
        });
    },
  },
};
</script>